import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import Linkify from 'react-linkify';
import { connect } from 'react-redux';
import * as IInputs from '../../../../../interfaces/merchants/resources/books/inputs';
import RichViewer from '../../../../common/editors/RichViewer';
import StringUtils from '../../../../utils/StringUtils';
import BookingWithPageDetailImage from './BookingWithPageDetailImage';

import css from './BookingWithPageDetail.module.scss';

interface ElementProps extends React.HTMLProps<{}> {
  className?: string;
  name: string;
  coverContentsType: string;
  primaryImage?: {
    meta: {
      width: number;
      height: number;
    };
    thumb?: {
      url: string;
    };
  };
  coverContent?: {
    url: string;
    embed: string;
    thumbnailUrl: string;
  };
  isJsonDescription: boolean;
  description?: string;
  descriptionText?: string;
}

interface StateProps {
  inputs: IInputs.State;
}

type Props = StateProps & InjectedIntlProps & ElementProps;

const initialShowBookingContentBy = (inputs: IInputs.State): boolean =>
  inputs.reservationId ? false : true;

const BookingWithPageDetail = (props: Props) => {
  const [showPageDetail, setShowPageDetail] = React.useState(
    initialShowBookingContentBy(props.inputs),
  );
  const showHideButtonClasses = classNames(
    css.BookingWithPageDetail__ShowHideButton,
    { [css.isHide]: !showPageDetail },
  );
  const showHideContentClasses = classNames(
    css.BookingWithPageDetail__ShowHideContents,
    { [css.isHide]: !showPageDetail },
  );

  return (
    <div className={classNames(css.BookingWithPageDetail, props.className)}>
      <div className={css.BookingWithPageDetail__PageDetail}>
        <div className={css.BookingWithPageDetail__Heading}>
          <div className={css.BookingWithPageDetail__Title}>{props.name}</div>
          <button
            className={showHideButtonClasses}
            onClick={ev => {
              ev.preventDefault();
              setShowPageDetail(!showPageDetail);
            }}
          >
            {props.intl.formatMessage({
              id: 'books.bookingWithPageDetail.detail',
            })}
          </button>
        </div>
        <div className={showHideContentClasses}>
          <div className={css.BookingWithPageDetail__Thumbnail}>
            {props.coverContentsType === 'upload_image' &&
              props.primaryImage && (
                <BookingWithPageDetailImage
                  name={props.name}
                  primaryImage={props.primaryImage}
                />
              )}
            {props.coverContentsType === 'embed' &&
              props.coverContent &&
              props.coverContent.embed && (
                <div
                  className={css.BookingWithPageDetail__Embed}
                  dangerouslySetInnerHTML={{
                    __html: props.coverContent.embed,
                  }}
                />
              )}
          </div>
          <div className={css.BookingWithPageDetail__Description}>
            {props.isJsonDescription && props.description ? (
              <RichViewer value={props.description} />
            ) : (
              props.descriptionText && (
                <Linkify>
                  {StringUtils.simpleFormat(props.descriptionText)}
                </Linkify>
              )
            )}
          </div>
        </div>
        <div className={css.BookingWithPageDetail__Clearfix} />
      </div>
      <div className={css.BookingWithPageDetail__BookingContents}>
        {props.children}
      </div>
    </div>
  );
};

const mapStateProps = ({
  merchantsResourcesBooksInputs,
}: {
  merchantsResourcesBooksInputs: IInputs.State;
}): StateProps => ({
  inputs: merchantsResourcesBooksInputs,
});

export default connect<StateProps, {}, ElementProps>(mapStateProps)(
  injectIntl<StateProps>(BookingWithPageDetail),
);
